import { onlyDigits } from "validators";

const applicationIdColumn = () => ({
	name: "number",
	type: "input" as const,
	placeholder: "App ID",
	normalize: onlyDigits,
});

export default applicationIdColumn;
